export enum ChartStaticBreakdownOptions {
  None = 'none',
  Total = 'total',
  Project = 'project',
  Team = 'team',
  CreatedBy = 'createdBy',
  WorkflowColumns = 'columns',
}
